module.exports = {
	h32: require("./xxhash")
,	h64: require("./xxhash64")
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/xxhashjs/lib/index.js
// module id = 506
// module chunks = 0